export class ArchivePaymentEntity {
  constructor() {
    this.id = null;
    this.fromAccountName = null;
    this.fromAccountId = null;
    this.toAccountName = null;
    this.reference = null;
    this.payType = null;
    this.category = null;
    this.accountNumber = null;
    this.type = null;
    // this.when = null;
    // this.amount = null;
  }
  getArchivePayment() {
    return this;
  }
}
export default ArchivePaymentEntity;
